import requestService from '../requestsService/requests.service';
import type {
  FollowFoodResponse,
  UnfollowFoodResponse,
  GetFollowerCountResponse,
} from '@bitecritic-api/src/food-followers/dto/food-followers.dto';

const basePath = '/food-followers';

export async function followFood(foodId: number): Promise<FollowFoodResponse> {
  const response = await requestService.post<FollowFoodResponse>(`${basePath}/${foodId}/follow`);
  return response.data;
}

export async function unfollowFood(foodId: number): Promise<UnfollowFoodResponse> {
  const response = await requestService.delete<UnfollowFoodResponse>(`${basePath}/${foodId}/unfollow`);
  return response.data;
}

export async function getFollowerCount(foodId: number): Promise<number> {
  const response = await requestService.fetch<GetFollowerCountResponse>(`${basePath}/${foodId}/follower-count`);
  if (!response) {
    throw new Error('Failed to fetch follower count');
  }
  return response.count;
}

const foodFollowersService = {
  followFood,
  unfollowFood,
  getFollowerCount,
};

export default foodFollowersService; 